"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveOrganizationTimezone = exports.getTimezoneForRegion = exports.COUNTRY_DEFAULT_TIMEZONE = exports.AU_STATE_SHORT_CODE_TO_TIMEZONE = exports.CA_PROVINCE_SHORT_CODE_TO_TIMEZONE = exports.US_STATE_SHORT_CODE_TO_TIMEZONE = void 0;
/* eslint-disable zeffy-linter/no-country-currency-condition -- legacy baseline (pre-rule); remove when these are migrated */
const luxon_1 = require("luxon");
const country_1 = require("../internationalization/enums/country");
/* eslint-disable @typescript-eslint/naming-convention */
exports.US_STATE_SHORT_CODE_TO_TIMEZONE = {
    AL: "America/Chicago",
    AK: "America/Anchorage",
    AZ: "America/Phoenix",
    AR: "America/Chicago",
    CA: "America/Los_Angeles",
    CO: "America/Denver",
    CT: "America/New_York",
    DE: "America/New_York",
    FL: "America/New_York",
    GA: "America/New_York",
    HI: "Pacific/Honolulu",
    ID: "America/Boise",
    IL: "America/Chicago",
    IN: "America/Indiana/Indianapolis",
    IA: "America/Chicago",
    KS: "America/Chicago",
    KY: "America/New_York",
    LA: "America/Chicago",
    ME: "America/New_York",
    MD: "America/New_York",
    MA: "America/New_York",
    MI: "America/Detroit",
    MN: "America/Chicago",
    MS: "America/Chicago",
    MO: "America/Chicago",
    MT: "America/Denver",
    NE: "America/Chicago",
    NV: "America/Los_Angeles",
    NH: "America/New_York",
    NJ: "America/New_York",
    NM: "America/Denver",
    NY: "America/New_York",
    NC: "America/New_York",
    ND: "America/Chicago",
    OH: "America/New_York",
    OK: "America/Chicago",
    OR: "America/Los_Angeles",
    PA: "America/New_York",
    RI: "America/New_York",
    SC: "America/New_York",
    SD: "America/Chicago",
    TN: "America/Chicago",
    TX: "America/Chicago",
    UT: "America/Denver",
    VT: "America/New_York",
    VA: "America/New_York",
    WA: "America/Los_Angeles",
    WV: "America/New_York",
    WI: "America/Chicago",
    WY: "America/Denver",
    DC: "America/New_York",
    PR: "America/Puerto_Rico",
    VI: "America/Virgin",
    GU: "Pacific/Guam",
    AS: "Pacific/Pago_Pago",
};
exports.CA_PROVINCE_SHORT_CODE_TO_TIMEZONE = {
    AB: "America/Edmonton",
    BC: "America/Vancouver",
    MB: "America/Winnipeg",
    NB: "America/Moncton",
    NL: "America/St_Johns",
    NS: "America/Halifax",
    ON: "America/Toronto",
    PE: "America/Halifax",
    QC: "America/Toronto",
    SK: "America/Regina",
    NT: "America/Yellowknife",
    NU: "America/Iqaluit",
    YT: "America/Whitehorse",
};
exports.AU_STATE_SHORT_CODE_TO_TIMEZONE = {
    NSW: "Australia/Sydney",
    VIC: "Australia/Melbourne",
    QLD: "Australia/Brisbane",
    SA: "Australia/Adelaide",
    WA: "Australia/Perth",
    TAS: "Australia/Hobart",
    NT: "Australia/Darwin",
    ACT: "Australia/Sydney",
};
exports.COUNTRY_DEFAULT_TIMEZONE = {
    [country_1.OrganizationCountry.UnitedStates]: "America/New_York",
    [country_1.OrganizationCountry.Canada]: "America/Toronto",
    [country_1.OrganizationCountry.GreatBritain]: "Europe/London",
    [country_1.OrganizationCountry.Australia]: "Australia/Sydney",
    [country_1.OrganizationCountry.NewZealand]: "Pacific/Auckland",
    [country_1.OrganizationCountry.Ireland]: "Europe/Dublin",
    [country_1.OrganizationCountry.Germany]: "Europe/Berlin",
};
const getTimezoneForRegion = (country, region) => {
    if (!region) {
        return exports.COUNTRY_DEFAULT_TIMEZONE[country];
    }
    const regionCode = region.trim().toUpperCase();
    switch (country) {
        case country_1.OrganizationCountry.UnitedStates:
            return exports.US_STATE_SHORT_CODE_TO_TIMEZONE[regionCode] || exports.COUNTRY_DEFAULT_TIMEZONE[country];
        case country_1.OrganizationCountry.Canada:
            return exports.CA_PROVINCE_SHORT_CODE_TO_TIMEZONE[regionCode] || exports.COUNTRY_DEFAULT_TIMEZONE[country];
        case country_1.OrganizationCountry.Australia:
            return exports.AU_STATE_SHORT_CODE_TO_TIMEZONE[regionCode] || exports.COUNTRY_DEFAULT_TIMEZONE[country];
        default:
            return exports.COUNTRY_DEFAULT_TIMEZONE[country];
    }
};
exports.getTimezoneForRegion = getTimezoneForRegion;
const resolveOrganizationTimezone = (organization) => organization.timezone && luxon_1.DateTime.now().setZone(organization.timezone).isValid
    ? organization.timezone
    : (0, exports.getTimezoneForRegion)(organization.country, organization.region);
exports.resolveOrganizationTimezone = resolveOrganizationTimezone;
